
import { useTranslation } from 'react-i18next';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-white border-t border-neutral-200">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 md:py-8">
        <div className="flex flex-col space-y-3 sm:space-y-4 md:flex-row md:justify-between md:items-center md:space-y-0 text-center md:text-left">
          <p className="text-neutral-600 text-xs sm:text-sm leading-relaxed">
            {t('footer.copyright')}
          </p>
          <div className="flex flex-col space-y-2 md:flex-row md:items-center md:space-y-0 md:space-x-4">
            <p className="text-neutral-600 text-xs sm:text-sm leading-relaxed">
              {t('footer.note')}
            </p>
            <a 
              href="https://readdy.ai/?origin=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-neutral-500 hover:text-neutral-700 text-xs sm:text-sm transition-colors cursor-pointer whitespace-nowrap"
            >
              Website Builder
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
